<template>
    <div>
        <div :class="{'show': toggleModal }" class="modal fade">
            <div class="modal-dialog" :class="action == 'add' ? 'modal-lg' : 'modal-dialog-centered'">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 fw-500">{{title}}
                        </h5>
                        <button type="button" class="close" @click="closeToggleModal">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body" :class="{'modal-body-lg': action == 'add'}">
                        <div v-if="action == 'add'">
                            <div class="text-right mb-3">
                                <router-link class="btn buttons-csv buttons-html5 btn-outline-primary" :to="'/dashboard/my_salon_tukang'" >
                                <span class="fal fa-plus mr-2"></span>
                                <span>{{$t('button_link.create') + $t('header.post')}}</span>
                            </router-link>
                            </div>
                            <div class="panel-tag mt-3" v-if="tukangPostItems.length == 0">
                                {{$t('table.no_records')}} {{$t('message.info.add_tukang', {'item': $t('header.post')})}}
                            </div>
                            <form v-else @submit.prevent="addTukangPost">
                                <div class="form-group w-100">
                                    <label class="form-label">{{'Tukang ' + $t('header.post')}}</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend w-100">
                                            <label class="input-group-text border-right-0">
                                                <i class="fas fa-comment-alt"></i>
                                            </label>
                                             <multiselect v-model="selectedPost"
                                                label="TkPostName" track-by="TkPostID" 
                                                :options="tukangPostItems" 
                                                :custom-label="customLabel" 
                                                :show-labels="false"
                                                @select="selectPost">
                                                <template slot="singleLabel" slot-scope="props">
                                                    <div class="row">
                                                        <div class="col-sm-12 col-md-4 d-flex align-items-center">
                                                            <div class="border bg-white tk-img-width text-center p-5" v-if="props.option.TkPostImage1 == ''">-</div>
                                                            <div v-else class="border bg-white p-2 text-center" style="border-radius: 8px;">
                                                                <img class="img-fluid tk-img-width option__image" :src="props.option.TkPostImage1">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12 col-md-8 d-flex align-items-center">
                                                            <div class="text-left">
                                                                <p class="fw-500 fs-xl text-dark">{{ props.option.TkPostName }}</p>
                                                                <h6 class="mt-3 fw-400 d-block border-bottom">
                                                                    <i class="fal fa-text mr-2"></i>
                                                                    {{$t('label.details')}}:
                                                                </h6>
                                                                <p class="d-block fw-300">{{props.option.TkPostDetails == '' ? '-' : props.option.TkPostDetails}}</p>
                                                                <h6 class="mt-3 fw-400 d-block border-bottom">
                                                                    <i class="fal fa-user mr-2"></i>
                                                                    {{$t('tukang.stylist')}}:
                                                                </h6>
                                                                <p class="d-block fw-300">{{props.option.TkStylistName == '' ? '-' : props.option.TkStylistName}}</p>
                                                                <flag :iso="props.option.DfCurrencyID == 1 ? 'my' : 'sg'" class="mr-1"/>{{props.option.DfCurrencyID == 1 ? 'MYR' : 'SGD'}}
                                                                <span class="mb-0 mr-2 fw-400">{{getDiscountPrice(props.option.TkPostPrice, props.option.TkPostDiscount)}}</span>
                                                                <span v-if="props.option.TkPostDiscount != '0' && props.option.TkPostDiscount != '0.00'"  class="mb-0 text-secondary fw-300 fs-xs" style="text-decoration: line-through">{{props.option.TkPostPrice}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template slot="option" slot-scope="props">
                                                    <div class="row border-bottom p-3">
                                                        <div class="col-sm-12 col-md-4 d-flex align-items-center">
                                                            <b-carousel v-if="props.option.TkPostImage.length != 0"
                                                                :no-touch="true"
                                                                indicators
                                                                controls
                                                                :interval="0">
                                                                <b-carousel-slide v-for="img in props.option.TkPostImage" :key="img.id"
                                                                    img-height="240"
                                                                    :img-src="img.src"
                                                                ></b-carousel-slide>
                                                            </b-carousel>
                                                            <span class="border bg-white tk-img-width text-center p-5" v-else>-</span>
                                                            <!-- <div class="border bg-white tk-img-width text-center p-5" v-if="props.option.TkPostImage1 == ''">-</div>
                                                            <div v-else class="border bg-white p-2 text-center" style="border-radius: 8px;">
                                                                <img class="img-fluid tk-img-width option__image" :src="props.option.TkPostImage1">
                                                            </div> -->
                                                        </div>
                                                        <div class="col-sm-12 col-md-8 d-flex align-items-center">
                                                            <div class="text-left">
                                                                <p class="fw-500 fs-xl text-dark">{{ props.option.TkPostName }}</p>
                                                                <h6 class="mt-3 fw-400 d-block border-bottom">
                                                                    <i class="fal fa-text mr-2"></i>
                                                                    {{$t('label.details')}}:
                                                                </h6>
                                                                <p class="d-block fw-300">{{props.option.TkPostDetails == '' ? '-' : props.option.TkPostDetails}}</p>
                                                                <h6 class="mt-3 fw-400 d-block border-bottom">
                                                                    <i class="fal fa-user mr-2"></i>
                                                                    {{$t('tukang.stylist')}}:
                                                                </h6>
                                                                <p class="d-block fw-300">{{props.option.TkStylistName == '' ? '-' : props.option.TkStylistName}}</p>
                                                                <flag :iso="props.option.DfCurrencyID == 1 ? 'my' : 'sg'" class="mr-1"/>{{props.option.DfCurrencyID == 1 ? 'MYR' : 'SGD'}}
                                                                <span class="mb-0 mr-2 fw-400">{{getDiscountPrice(props.option.TkPostPrice, props.option.TkPostDiscount)}}</span>
                                                                <span v-if="props.option.TkPostDiscount != '0' && props.option.TkPostDiscount != '0.00'"  class="mb-0 text-secondary fw-300 fs-xs" style="text-decoration: line-through">{{props.option.TkPostPrice}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-left button-container">
                                    <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                                </div>
                            </form>
                        </div>
                        <div v-else>
                            <p>{{$t('message.confirmation.question', {'action': $t('message.confirmation.action.delete'), 'item': tukangPostName})}}</p>
                            <div class="text-right pt-3 mb-1">
                                <button type="button" class="btn btn-secondary waves-effect waves-themed mr-3" @click="toggleModal = false">{{$t('button_link.cancel')}}</button>
                                <button id="btnDeleteRewardYes" type="button" class="btn btn-primary waves-effect waves-themed" @click="deleteTukangPost">{{$t('button_link.yes')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
import {formatPrice} from './../../../../assets/js/dashboard/utilities'
export default {
    name: 'broadcastTukang',
    props:{
        tukangPostItems: Array
    },
    data(){
        return{
            toggleModal: false,
            action: 'add', title: '',
            bcastID: 0,
            tukangPostName: '', tukangPostID: 0,
            selectedPost: {}
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.$emit('returnBroadcast')
                this.closeToggleModal()
            }
            this.$parent.$parent.isModalShow = false
        },
        customLabel ({ title, desc }) {
            return `${title} – ${desc}`
        },
        getDiscountPrice(price, discount){
            var newPrice = parseFloat(price) - parseFloat(discount)
            return formatPrice(newPrice)
        },
        setBroadcastTukang(item, action){
            this.bcastID = item.bcastID
            this.action = action
            this.title = action == 'add' ? this.$i18n.t('header.add') + 'Tukang ' + this.$i18n.t('header.post') : this.$i18n.t('header.delete', {'item': 'Tukang ' + this.$i18n.t('header.post')})
           
            this.tukangPostName = item.tkPostName
            this.tukangPostID = item.tkPostID

            this.toggleModal = true
        },
        closeToggleModal(){
            this.selectedPost = this.tukangPostItems[0]
            this.toggleModal = false
        },
        selectPost(item){
            this.selectedPost = item
        },
        addTukangPost(){
            const url = this.$api.BROADCAST + "/" + this.bcastID + this.$api.BROADCAST_TUKANG

            let $vm = this;

            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: {tkPostID: this.selectedPost.TkPostID}
            })
            .then(function(response) {
                if(response.status == 200){
                    var message = 'Tukang ' + $vm.$i18n.t('header.post') +  $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.add')})
                    $vm.$parent.$parent.setModal($vm, false, true, message)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired($vm.selectedOutlet);   
                }
            })
        },
        deleteTukangPost(){
            const url = this.$api.BROADCAST + "/" + this.bcastID + this.$api.BROADCAST_TUKANG + this.$api.DELETE

            let $vm = this;
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then(function(response) {
                if(response.status == 200){
                    var message = 'Tukang ' + $vm.$i18n.t('header.post') +  $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.delete')})
                    $vm.$parent.$parent.setModal($vm, false, true, message)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
    },
    mounted(){
        let $vm = this
        $vm.selectedPost = $vm.tukangPostItems[0]
    },
}
</script>
<style scoped>
.show{
    display: block;
}
.tk-img-width{
    width: 10em !important;
}
.modal-body-lg{
    min-height: 75vh;
    max-height: 85vh;
    overflow-y: auto;
}
.button-container{
    position: absolute;
    bottom: 8%;
}
</style>